(function (root, factory) {
  'use strict';
  // Shopify can evaluate a section's asset again in the theme editor.
  var api = root && root.MNPasswordLaunch ? root.MNPasswordLaunch : factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MNPasswordLaunch = api;
  if (root && root.document) api.init(root.document);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var DEFAULT_LAUNCH_AT = '2026-09-21T18:00:00-04:00';
  var DEFAULT_PROGRESS_START = '2026-09-18T18:00:00-04:00';
  var TIMING_ERROR = 'Launch timing is being updated.';
  var units = ['days', 'hours', 'minutes', 'seconds'];
  var bindings = new WeakMap();
  var pending = new WeakMap();

  function parseInstant(value) {
    if (typeof value !== 'string') return NaN;
    var text = value.trim();
    var parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(Z|[+-]\d{2}:\d{2})$/.exec(text);
    if (!parts) return NaN;
    var year = Number(parts[1]);
    var month = Number(parts[2]);
    var day = Number(parts[3]);
    var leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    var monthDays = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month < 1 || month > 12 || day < 1 || day > monthDays[month - 1] ||
        Number(parts[4]) > 23 || Number(parts[5]) > 59 || Number(parts[6] || 0) > 59) return NaN;
    var offset = parts[8];
    if (offset !== 'Z' && (Number(offset.slice(1, 3)) > 23 || Number(offset.slice(4)) > 59)) return NaN;
    return Date.parse(text);
  }

  function parseSettings(settings) {
    settings = settings || {};
    var launchAt = settings.launchAt == null ? DEFAULT_LAUNCH_AT : settings.launchAt;
    var progressStart = settings.progressStart == null ? DEFAULT_PROGRESS_START : settings.progressStart;
    var launchMs = parseInstant(launchAt);
    var progressStartMs = parseInstant(progressStart);
    if (!Number.isFinite(launchMs) || !Number.isFinite(progressStartMs) || progressStartMs >= launchMs) {
      return { valid: false, message: TIMING_ERROR };
    }
    return { valid: true, launchMs: launchMs, progressStartMs: progressStartMs };
  }

  function getState(nowMs, settings) {
    if (nowMs === undefined) nowMs = Date.now();
    var timing = parseSettings(settings);
    if (!timing.valid || !Number.isFinite(nowMs)) return { valid: false, message: TIMING_ERROR };
    var launched = nowMs >= timing.launchMs;
    var remainingMs = Math.max(0, timing.launchMs - nowMs);
    var remainingSeconds = Math.ceil(remainingMs / 1000);
    var percent = launched ? 100 : Math.min(99.99, Math.max(0,
      (nowMs - timing.progressStartMs) / (timing.launchMs - timing.progressStartMs) * 100));
    return {
      valid: true,
      launched: launched,
      remainingMs: remainingMs,
      remainingSeconds: remainingSeconds,
      days: Math.floor(remainingSeconds / 86400),
      hours: Math.floor(remainingSeconds % 86400 / 3600),
      minutes: Math.floor(remainingSeconds % 3600 / 60),
      seconds: remainingSeconds % 60,
      percent: percent
    };
  }

  function formatCountdown(state) {
    if (!state.valid) return TIMING_ERROR;
    if (state.launched) return 'Scheduled launch time reached.';
    return units.map(function (unit) {
      return state[unit] + ' ' + unit.slice(0, -1) + (state[unit] === 1 ? '' : 's');
    }).join(', ') + ' until the scheduled launch.';
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function findWidgets(scope) {
    var result = [];
    if (!scope) return result;
    if (scope.matches && scope.matches('[data-launch-widget]')) result.push(scope);
    if (scope.querySelectorAll) result = result.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-launch-widget]')));
    return result;
  }

  function prepare(widget) {
    var countdown = widget.querySelector('[data-launch-countdown]');
    if (countdown) {
      countdown.setAttribute('role', 'timer');
      countdown.setAttribute('aria-live', 'off');
    }
    var status = widget.querySelector('[data-launch-status]');
    if (status) {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
    }
    var progress = widget.querySelector('[data-launch-progress]');
    if (progress) {
      progress.setAttribute('role', 'progressbar');
      progress.setAttribute('aria-valuemin', '0');
      progress.setAttribute('aria-valuemax', '100');
      progress.setAttribute('aria-live', 'off');
    }
    return { widget: widget, hiddenNodes: new Map() };
  }

  function renderWidget(record, nowMs) {
    var widget = record.widget;
    var state = getState(nowMs, {
      launchAt: widget.getAttribute('data-launch-at'),
      progressStart: widget.getAttribute('data-progress-start')
    });
    var countdown = widget.querySelector('[data-launch-countdown]');
    var progress = widget.querySelector('[data-launch-progress]');
    if (!state.valid) {
      widget.querySelectorAll('[data-launch-countdown], [data-launch-loader], [data-launch-progress], [data-launch-percent], [data-launch-fill], [data-unit]').forEach(function (node) {
        if (!record.hiddenNodes.has(node)) record.hiddenNodes.set(node, node.hidden);
        node.hidden = true;
      });
      widget.setAttribute('data-launch-state', 'invalid');
      if (progress) {
        progress.removeAttribute('aria-valuenow');
        progress.removeAttribute('aria-valuetext');
      }
      setText(widget.querySelector('[data-launch-status]'), TIMING_ERROR);
      setText(widget.querySelector('[data-launch-message]'), TIMING_ERROR);
      return state;
    }
    record.hiddenNodes.forEach(function (hidden, node) { node.hidden = hidden; });
    record.hiddenNodes.clear();
    units.forEach(function (unit) {
      widget.querySelectorAll('[data-unit="' + unit + '"]').forEach(function (node) {
        setText(node, String(state[unit]).padStart(2, '0'));
      });
    });
    var percent = state.percent.toFixed(2);
    if (countdown) countdown.setAttribute('aria-label', formatCountdown(state));
    setText(widget.querySelector('[data-launch-percent]'), percent + '%');
    var fill = widget.querySelector('[data-launch-fill]');
    if (fill) {
      fill.style.width = percent + '%';
      fill.style.setProperty('--progress', percent + '%');
    }
    if (progress) {
      progress.setAttribute('aria-valuenow', percent);
      progress.setAttribute('aria-valuetext', percent + '% of the countdown completed');
    }
    widget.setAttribute('data-launch-state', state.launched ? 'ready' : 'countdown');
    setText(widget.querySelector('[data-launch-status]'), state.launched ? 'Ready to launch' : 'Giveaway loading');
    setText(widget.querySelector('[data-launch-message]'), state.launched ? 'Scheduled launch time reached.' : '');
    return state;
  }

  function bind(doc, options) {
    if (!doc || !doc.querySelectorAll) return null;
    if (bindings.has(doc)) {
      var existing = bindings.get(doc);
      existing.load(doc);
      return existing;
    }
    options = options || {};
    var now = options.now || Date.now;
    var startInterval = options.setInterval || setInterval;
    var stopInterval = options.clearInterval || clearInterval;
    var records = new Map();
    var intervalId = null;
    var destroyed = false;
    var view = doc.defaultView;

    function openRulesAtHash(hash) {
      if (!hash || hash.charAt(0) !== '#' || !doc.getElementById) return;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return; }
      var rules = doc.getElementById('password-official-rules');
      var target = doc.getElementById(id);
      if (rules && rules.tagName === 'DETAILS' && target && rules.contains(target)) rules.open = true;
    }

    function openCurrentRulesHash() {
      if (view && view.location) openRulesAtHash(view.location.hash);
    }

    function rulesLinkClick(event) {
      var target = event.target;
      var link = target && target.closest ? target.closest('[data-open-password-rules]') : null;
      if (link) openRulesAtHash(link.getAttribute('href'));
      // Keep native anchor navigation and all password form behavior intact.
    }

    function render() {
      if (destroyed) return [];
      var currentTime = now();
      var states = [];
      records.forEach(function (record) { states.push(renderWidget(record, currentTime)); });
      var needsTick = states.some(function (state) { return state.valid && !state.launched; });
      if (needsTick && intervalId === null) intervalId = startInterval(render, 1000);
      if (!needsTick && intervalId !== null) {
        stopInterval(intervalId);
        intervalId = null;
      }
      return states;
    }

    function load(scope) {
      if (destroyed) return;
      findWidgets(scope).forEach(function (widget) {
        if (!records.has(widget)) records.set(widget, prepare(widget));
      });
      openCurrentRulesHash();
      render();
    }

    function unload(scope) {
      records.forEach(function (record, widget) {
        if (scope === widget || (scope && scope.contains && scope.contains(widget))) records.delete(widget);
      });
      render();
    }

    function sectionLoad(event) { load(event.target); }
    function sectionUnload(event) { unload(event.target); }
    var controller = {
      render: render,
      load: load,
      unload: unload,
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        if (intervalId !== null) stopInterval(intervalId);
        intervalId = null;
        records.clear();
        doc.removeEventListener('shopify:section:load', sectionLoad);
        doc.removeEventListener('shopify:section:unload', sectionUnload);
        doc.removeEventListener('click', rulesLinkClick);
        if (view) view.removeEventListener('hashchange', openCurrentRulesHash);
        bindings.delete(doc);
      }
    };
    bindings.set(doc, controller);
    doc.addEventListener('shopify:section:load', sectionLoad);
    doc.addEventListener('shopify:section:unload', sectionUnload);
    doc.addEventListener('click', rulesLinkClick);
    if (view) view.addEventListener('hashchange', openCurrentRulesHash);
    load(doc);
    return controller;
  }

  function init(doc, options) {
    if (!doc || !doc.addEventListener) return null;
    if (doc.readyState !== 'loading') return bind(doc, options);
    if (pending.has(doc)) return pending.get(doc);
    function ready() {
      pending.delete(doc);
      bind(doc, options);
    }
    var controller = {
      destroy: function () {
        doc.removeEventListener('DOMContentLoaded', ready);
        pending.delete(doc);
      }
    };
    pending.set(doc, controller);
    doc.addEventListener('DOMContentLoaded', ready, { once: true });
    return controller;
  }

  return {
    DEFAULT_LAUNCH_AT: DEFAULT_LAUNCH_AT,
    DEFAULT_PROGRESS_START: DEFAULT_PROGRESS_START,
    parseSettings: parseSettings,
    getState: getState,
    formatCountdown: formatCountdown,
    bind: bind,
    init: init
  };
}));
